/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * ChatAgent.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  OAuthCallbackRequest
} from '.././model';

import { customInstance } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getApiOauthProviderAuthorize = (
    provider: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/oauth/${provider}/authorize`, method: 'GET', signal
    },
      options);
    }
  



export const getGetApiOauthProviderAuthorizeQueryKey = (provider?: string,) => {
    return [
    `/api/oauth/${provider}/authorize`
    ] as const;
    }

    
export const getGetApiOauthProviderAuthorizeQueryOptions = <TData = Awaited<ReturnType<typeof getApiOauthProviderAuthorize>>, TError = unknown>(provider: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOauthProviderAuthorize>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiOauthProviderAuthorizeQueryKey(provider);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOauthProviderAuthorize>>> = ({ signal }) => getApiOauthProviderAuthorize(provider, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(provider),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiOauthProviderAuthorize>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiOauthProviderAuthorizeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOauthProviderAuthorize>>>
export type GetApiOauthProviderAuthorizeQueryError = unknown


export function useGetApiOauthProviderAuthorize<TData = Awaited<ReturnType<typeof getApiOauthProviderAuthorize>>, TError = unknown>(
 provider: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOauthProviderAuthorize>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOauthProviderAuthorize>>,
          TError,
          Awaited<ReturnType<typeof getApiOauthProviderAuthorize>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiOauthProviderAuthorize<TData = Awaited<ReturnType<typeof getApiOauthProviderAuthorize>>, TError = unknown>(
 provider: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOauthProviderAuthorize>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOauthProviderAuthorize>>,
          TError,
          Awaited<ReturnType<typeof getApiOauthProviderAuthorize>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiOauthProviderAuthorize<TData = Awaited<ReturnType<typeof getApiOauthProviderAuthorize>>, TError = unknown>(
 provider: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOauthProviderAuthorize>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiOauthProviderAuthorize<TData = Awaited<ReturnType<typeof getApiOauthProviderAuthorize>>, TError = unknown>(
 provider: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOauthProviderAuthorize>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiOauthProviderAuthorizeQueryOptions(provider,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postApiOauthProviderCallback = (
    provider: string,
    oAuthCallbackRequest: OAuthCallbackRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/oauth/${provider}/callback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: oAuthCallbackRequest, signal
    },
      options);
    }
  


export const getPostApiOauthProviderCallbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOauthProviderCallback>>, TError,{provider: string;data: OAuthCallbackRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiOauthProviderCallback>>, TError,{provider: string;data: OAuthCallbackRequest}, TContext> => {

const mutationKey = ['postApiOauthProviderCallback'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiOauthProviderCallback>>, {provider: string;data: OAuthCallbackRequest}> = (props) => {
          const {provider,data} = props ?? {};

          return  postApiOauthProviderCallback(provider,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiOauthProviderCallbackMutationResult = NonNullable<Awaited<ReturnType<typeof postApiOauthProviderCallback>>>
    export type PostApiOauthProviderCallbackMutationBody = OAuthCallbackRequest
    export type PostApiOauthProviderCallbackMutationError = unknown

    export const usePostApiOauthProviderCallback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOauthProviderCallback>>, TError,{provider: string;data: OAuthCallbackRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiOauthProviderCallback>>,
        TError,
        {provider: string;data: OAuthCallbackRequest},
        TContext
      > => {

      const mutationOptions = getPostApiOauthProviderCallbackMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    